import React from "react";
import SectionLabel from "./SectionLabel";

const FeaturedMarquee = ({ items }) => {
  return (
    <section className="scroll-mt-24">
      <SectionLabel>Things I made</SectionLabel>
      <div className="-mx-6 flex gap-3.5 overflow-x-auto px-6 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {items.map((item) => (
          <a
            key={item.id}
            href={item.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group/tweet relative h-56 w-[min(280px,72vw)] shrink-0 snap-start overflow-hidden rounded-2xl border border-zinc-200 bg-zinc-100 dark:border-zinc-800 dark:bg-zinc-900"
          >
            <img
              src={item.image}
              alt={item.title}
              className="h-full w-full object-cover transition-transform duration-500 group-hover/tweet:scale-105"
            />
            <div className="absolute inset-0 z-10 flex flex-col justify-end bg-black/60 p-4 opacity-0 transition-opacity duration-300 group-hover/tweet:opacity-100">
              <p className="mb-1 text-xs font-medium text-zinc-300">{item.date}</p>
              <p className="line-clamp-3 text-sm font-medium leading-snug text-white">
                {item.title}
              </p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default FeaturedMarquee;
